module.exports = __webpack_public_path__ + "static/media/keto.2b324ca3.png";